(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[281],{

/***/ 32938:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/client-settings",
      function () {
        return __webpack_require__(63422);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ ClientConfig; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/utils.ts
var utils = __webpack_require__(90759);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 9 modules
var Form = __webpack_require__(3162);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/InputGroup.js + 1 modules
var InputGroup = __webpack_require__(71604);
// EXTERNAL MODULE: ./node_modules/react-bootstrap-time-picker/dist/bundle.js
var bundle = __webpack_require__(32574);
var bundle_default = /*#__PURE__*/__webpack_require__.n(bundle);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./components/client/VitalsConfigureView.tsx




var VitalsConfigureView = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var handleChange = function(e) {
        if (e.target.checked) {
            if (props.vitals) {
                props.updateVitals((0,_to_consumable_array/* default */.Z)(props.vitals).concat([
                    e.target.id
                ]));
            } else {
                props.updateVitals([
                    e.target.id
                ]);
            }
        } else {
            props.updateVitals(props.vitals.filter(function(v) {
                return v != e.target.id;
            }));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fs-7 text-info",
        children: utils/* vitals.map */.C0.map(function(v) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-check d-inline-block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: "form-check-input",
                        type: "checkbox",
                        value: "",
                        onChange: handleChange,
                        id: v.id,
                        checked: props.vitals && props.vitals.filter(function(pv) {
                            return pv == v.id;
                        }).length > 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "form-check-label",
                        htmlFor: "flexCheckDefault",
                        children: [
                            v.name,
                            "\xa0\xa0\xa0\xa0"
                        ]
                    })
                ]
            }, v.name);
        })
    });
});
VitalsConfigureView.displayName = "VitalsConfigureView";

;// CONCATENATED MODULE: ./components/client/ClientConfig.tsx







var ClientConfig = function(props) {
    var getDaySessions = function getDaySessions(day) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    className: "bg-light py-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-weight-bold text-info",
                            children: day.name
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    className: "py-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: day.sessions && day.sessions.map(function(session) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex justify-content-between my-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "align-self-center",
                                            children: "Start"
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((bundle_default()), {
                                            value: session.startTime,
                                            disabled: true,
                                            size: "sm"
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "align-self-center",
                                            children: "End"
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((bundle_default()), {
                                            value: session.endTime,
                                            disabled: true,
                                            size: "sm"
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            className: "btn btn-outline-danger text-danger font-weight-bold bg-white",
                                            size: "sm",
                                            onClick: function() {
                                                return handleRemoveSession(day.name, session.startTime, session.endTime);
                                            },
                                            children: "X"
                                        })
                                    ]
                                })
                            });
                        })
                    })
                })
            ]
        });
    };
    var getAddSessionForm = function getAddSessionForm() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            className: "pt-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-control",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                    className: "form-select form-select-sm my-3",
                                    value: addSessionDay,
                                    onChange: function(e) {
                                        return setAddSessionDay(e.target.value);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "MON",
                                            children: "Monday"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "TUE",
                                            children: "Tuesday"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "WED",
                                            children: "Wednesday"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "THU",
                                            children: "Thursday"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "FRI",
                                            children: "Friday"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "SAT",
                                            children: "Saturday"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "SUN",
                                            children: "Sunday"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "ALL",
                                            children: "All Days"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "WEEKDAYS",
                                            children: "Week days"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "MON-SAT",
                                            children: "Monday to Saturday"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "WEEKENDS",
                                            children: "Weekends"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex justify-content-between my-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "align-self-center fs-7 text-info",
                                            children: "Start:\xa0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((bundle_default()), {
                                            start: "01:00",
                                            end: "23:30",
                                            step: 30,
                                            value: addStartTime,
                                            size: "sm",
                                            onChange: setAddStartTime
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "align-self-center fs-7 text-info",
                                            children: "\xa0End:\xa0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((bundle_default()), {
                                            start: "01:00",
                                            end: "23:30",
                                            step: 30,
                                            value: addEndTime,
                                            size: "sm",
                                            onChange: setAddEndTime
                                        }),
                                        "\xa0"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "my-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        className: "btn btn-warning text-white font-weight-bold",
                                        size: "sm",
                                        onClick: handleAddSession,
                                        children: "Add Session Timing"
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        });
    };
    var ref = (0,react.useState)([]), sessionDetails = ref[0], setSessionDetails = ref[1];
    var ref1 = (0,react.useState)("MON"), addSessionDay = ref1[0], setAddSessionDay = ref1[1];
    var ref2 = (0,react.useState)(18000), addStartTime = ref2[0], setAddStartTime = ref2[1];
    var ref3 = (0,react.useState)(21600), addEndTime = ref3[0], setAddEndTime = ref3[1];
    var ref4 = (0,react.useState)(false), futureAppointments = ref4[0], setFutureAppointments = ref4[1];
    var ref5 = (0,react.useState)(false), callPaidNext = ref5[0], setCallPaidNext = ref5[1];
    var ref6 = (0,react.useState)(false), onlineAppointments = ref6[0], setOnlineAppointments = ref6[1];
    var ref7 = (0,react.useState)(true), printPatientDetails = ref7[0], setPrintPatientDetails = ref7[1];
    var ref8 = (0,react.useState)("5"), standardFollowUp = ref8[0], setStandardFollowUp = ref8[1];
    var ref9 = (0,react.useState)(), consultationFee = ref9[0], setConsultationFee = ref9[1];
    var ref10 = (0,react.useState)(), topMargin = ref10[0], setTopMargin = ref10[1];
    var ref11 = (0,react.useState)(), bottomMargin = ref11[0], setBottomMargin = ref11[1];
    var ref12 = (0,react.useState)(), leftMargin = ref12[0], setLeftMargin = ref12[1];
    var ref13 = (0,react.useState)([]), vitalsToCollect = ref13[0], setVitalsToCollect = ref13[1];
    var ref14 = (0,react.useState)(null), error = ref14[0], setError = ref14[1];
    var ref15 = (0,react.useState)(null), success = ref15[0], setSuccess = ref15[1];
    (0,react.useEffect)(function() {
        if (props.cookieQr) {
            axios_default().get("/api/backend/client/config/fetch/" + props.cookieQr).then(function(resp) {
                if (resp.data) {
                    setSessionDetails(JSON.parse(resp.data.sessions));
                    setFutureAppointments(resp.data.futureAppointments);
                    setCallPaidNext(resp.data.callPaidNext);
                    setConsultationFee(resp.data.consultationFee);
                    setOnlineAppointments(resp.data.qmeActive);
                    setPrintPatientDetails(resp.data.printPatientDetails);
                    setVitalsToCollect(JSON.parse(resp.data.vitals));
                    setStandardFollowUp(resp.data.followUpAfter);
                    var templateSettings = JSON.parse(resp.data.templateSetting);
                    if (templateSettings) {
                        setLeftMargin(templateSettings.leftMargin);
                        setTopMargin(templateSettings.topMargin);
                        setBottomMargin(templateSettings.bottomMargin);
                    }
                }
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            }).finally(function() {});
        }
    }, [
        props.cookieQr
    ]);
    var handleSaveConfigurations = function() {
        setError(null);
        setSuccess(null);
        var headers = {
            headers: {
                "Content-Type": "application/json"
            }
        };
        axios_default().post("/api/backend/client/config/save", {
            futureAppointments: futureAppointments,
            callPaidNext: callPaidNext,
            qmeActive: onlineAppointments,
            printPatientDetails: printPatientDetails,
            followUpAfter: standardFollowUp,
            vitals: JSON.stringify(vitalsToCollect),
            consultationFee: Number.parseFloat(consultationFee),
            templateSetting: JSON.stringify({
                leftMargin: leftMargin,
                topMargin: topMargin,
                bottomMargin: bottomMargin
            }),
            qr: props.cookieQr,
            sessions: JSON.stringify(sessionDetails)
        }, headers).then(function(resp) {
            setSuccess("* Successfully updated the configurations");
        }).catch(function(err) {
            setError("* Something went wrong");
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        }).finally(function() {});
    };
    var handleAddSession = function() {
        var day = sessionDetails.filter(function(s) {
            return s.name == addSessionDay;
        }).at(0);
        var updatedDay = day ? day : {
            name: addSessionDay,
            sessions: []
        };
        var newSession = {
            startTime: addStartTime,
            endTime: addEndTime
        };
        if (updatedDay.sessions && updatedDay.sessions.filter(function(s) {
            return s.startTime == newSession.startTime && s.endTime == newSession.endTime;
        }).length > 0) {
            return;
        }
        updatedDay.sessions.push(newSession);
        var updatedSessionDetails = sessionDetails.filter(function(s) {
            return s.name != addSessionDay;
        });
        updatedSessionDetails.push(updatedDay);
        setSessionDetails(updatedSessionDetails);
        console.log(JSON.stringify(sessionDetails));
    };
    var handleRemoveSession = function(removeDay, removeStartTime, removeEndTime) {
        var updatedDay = sessionDetails.filter(function(s) {
            return s.name == removeDay;
        }).at(0);
        var updatedSessions = updatedDay.sessions.filter(function(s) {
            return !(s.startTime == removeStartTime && s.endTime == removeEndTime);
        });
        updatedDay.sessions = updatedSessions;
        var updatedSessionDetails = sessionDetails.filter(function(s) {
            return s.name != removeDay;
        });
        if (updatedSessions && updatedSessions.length > 0) {
            updatedSessionDetails.push(updatedDay);
        }
        setSessionDetails(updatedSessionDetails);
        console.log(JSON.stringify(sessionDetails));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: "text-primary mb-4 text-decoration-underline",
                            children: "Session Timings"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fs-7 text-info",
                            children: [
                                sessionDetails && sessionDetails.length > 0 && sessionDetails.map(function(day) {
                                    return getDaySessions(day);
                                }),
                                !sessionDetails || sessionDetails.length == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "font-italic",
                                    children: "Timings not provided yet."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: getAddSessionForm()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    className: "text-primary my-4 text-decoration-underline",
                                    children: "Other Configurations"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                                    className: "fs-7 text-info",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Check */.Z.Check, {
                                            type: "switch",
                                            id: "custom-switch",
                                            checked: futureAppointments,
                                            className: "my-2",
                                            onChange: function(e) {
                                                return setFutureAppointments(e.target.checked);
                                            },
                                            label: "Enable Future date Appointments"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Check */.Z.Check, {
                                            type: "switch",
                                            id: "custom-switch",
                                            className: "my-2",
                                            checked: callPaidNext,
                                            onChange: function(e) {
                                                return setCallPaidNext(e.target.checked);
                                            },
                                            label: "Skip Unpaid Patients"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Check */.Z.Check, {
                                            type: "switch",
                                            id: "custom-switch",
                                            className: "my-2",
                                            checked: onlineAppointments,
                                            onChange: function(e) {
                                                return setOnlineAppointments(e.target.checked);
                                            },
                                            label: "Enable Online Appointments"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Check */.Z.Check, {
                                            type: "switch",
                                            id: "custom-switch",
                                            className: "my-2",
                                            checked: printPatientDetails,
                                            onChange: function(e) {
                                                return setPrintPatientDetails(e.target.checked);
                                            },
                                            label: "Print Patient Details on Prescription"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                            as: Row/* default */.Z,
                                            className: "my-3",
                                            controlId: "consultationFee",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Label */.Z.Label, {
                                                    className: "text-info",
                                                    column: true,
                                                    sm: 6,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            alt: "session-management",
                                                            src: "/emr/reminder.png",
                                                            width: "20",
                                                            height: "20"
                                                        }),
                                                        "\xa0\xa0Standard Follow-up Reminder"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    sm: 6,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputGroup/* default */.Z, {
                                                            className: "",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    className: "form-control form-control-sm",
                                                                    type: "number",
                                                                    onChange: function(e) {
                                                                        return setStandardFollowUp(e.target.value);
                                                                    },
                                                                    value: standardFollowUp
                                                                }),
                                                                "\xa0\xa0 Days"
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-info my-4 fs-6",
                                            children: "Vitals To be Collected"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VitalsConfigureView, {
                                            vitals: vitalsToCollect,
                                            updateVitals: setVitalsToCollect
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                            as: Row/* default */.Z,
                                            className: "my-3",
                                            controlId: "consultationFee",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                    className: "fs-6",
                                                    column: true,
                                                    sm: 6,
                                                    children: "Consultation Fee in ₹:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    sm: 6,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                        value: consultationFee,
                                                        size: "sm",
                                                        onChange: function(e) {
                                                            return setConsultationFee(e.target.value);
                                                        },
                                                        name: "consultationFee",
                                                        type: "number",
                                                        className: "d-inline-block",
                                                        placeholder: "Enter Consultation Fee"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                            className: "my-3",
                                            controlId: "templateSettings",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                    className: "fs-6",
                                                    children: "Prescription Printing Template Settings:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                                    as: Row/* default */.Z,
                                                    className: "my-2",
                                                    controlId: "left-margin",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                            column: true,
                                                            sm: 6,
                                                            children: "Left-Margin in pixels:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                            sm: 6,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                                value: leftMargin,
                                                                onChange: function(e) {
                                                                    return setLeftMargin(e.target.value);
                                                                },
                                                                size: "sm",
                                                                name: "leftMargin",
                                                                type: "text",
                                                                className: "my-2",
                                                                placeholder: "Enter left margin"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                                    as: Row/* default */.Z,
                                                    className: "my-2",
                                                    controlId: "top-margin",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                            column: true,
                                                            sm: 6,
                                                            children: "Top-Margin in pixels:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                            sm: 6,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                                value: topMargin,
                                                                onChange: function(e) {
                                                                    return setTopMargin(e.target.value);
                                                                },
                                                                size: "sm",
                                                                name: "topMargin",
                                                                type: "text",
                                                                className: "my-2",
                                                                placeholder: "Enter top margin"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                                    as: Row/* default */.Z,
                                                    className: "my-2",
                                                    controlId: "bottom-margin",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                            column: true,
                                                            sm: 6,
                                                            children: "Bottom-Margin in pixels:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                            sm: 6,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                                value: bottomMargin,
                                                                onChange: function(e) {
                                                                    return setBottomMargin(e.target.value);
                                                                },
                                                                size: "sm",
                                                                name: "bottomMargin",
                                                                type: "text",
                                                                className: "my-2",
                                                                placeholder: "Enter bottom margin"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                className: "pt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "btn btn-info text-white ",
                            onClick: handleSaveConfigurations,
                            children: "Save Configurations"
                        }),
                        success && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-success fs-5",
                            children: success
                        }),
                        error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-danger fs-5",
                            children: error
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 63422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ client_settings; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 6 modules
var useCookies = __webpack_require__(70461);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/utils.ts
var utils = __webpack_require__(90759);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./components/client/ClientConfig.tsx + 1 modules
var ClientConfig = __webpack_require__(34640);
// EXTERNAL MODULE: ./components/permissions.ts
var permissions = __webpack_require__(13677);
;// CONCATENATED MODULE: ./components/client/self/ClientSettingsView.tsx








var ClientSettingsView = function(props) {
    var loadEntityData = function loadEntityData() {
        axios_default().get("/api/backend/entity/profile/" + props.cookieEntityQr).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setUsers(resp.data.users);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var getUsers = function getUsers() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-primary fs-5",
                    children: "Front Desk Users"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                    className: "table",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "Mobile"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                            children: [
                                users.map(function(user) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: user.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: user.mobile
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "btn btn-sm btn-outline-warning bg-white",
                                                    onClick: function(e) {
                                                        return handleRemove(user);
                                                    },
                                                    children: "X"
                                                })
                                            })
                                        ]
                                    }, user);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                value: name,
                                                onChange: function(e) {
                                                    return setName(e.target.value);
                                                },
                                                className: "form-control form-control-sm",
                                                placeholder: "Enter Name"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "tel",
                                                value: mobile,
                                                onChange: function(e) {
                                                    return setMobile(e.target.value);
                                                },
                                                className: "form-control form-control-sm",
                                                placeholder: "Enter Mobile"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "btn btn-sm btn-success text-white",
                                                onClick: handleAddUser,
                                                children: "+"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "my-3 text-danger fs-6",
                    children: error
                })
            ]
        });
    };
    var ref = (0,react.useState)(false), isBasic = ref[0], setIsBasic = ref[1];
    var ref1 = (0,react.useState)([]), users = ref1[0], setUsers = ref1[1];
    var ref2 = (0,react.useState)(null), name = ref2[0], setName = ref2[1];
    var ref3 = (0,react.useState)(null), mobile = ref3[0], setMobile = ref3[1];
    var ref4 = (0,react.useState)(null), error = ref4[0], setError = ref4[1];
    (0,react.useEffect)(function() {
        // Perform localStorage action
        setIsBasic(!(localStorage.getItem("opd") == "true") && !(localStorage.getItem("ipd") == "true") && !(localStorage.getItem("inventory") == "true") && !(localStorage.getItem("radiology") == "true") && !(localStorage.getItem("lab") == "true"));
    }, []);
    (0,react.useEffect)(function() {
        // Perform localStorage action
        loadEntityData();
    }, [
        props.cookieEntityQr
    ]);
    var handleRemove = function(user) {
        setError(null);
        console.log("Deleting user");
        axios_default().post("/api/backend/user/remove", {
            mobile: user.mobile,
            qrCode: user.qrCode,
            role: user.role
        }).then(function(resp) {
            loadEntityData();
        }).catch(function(err) {
            setError("* Removing user failed. Please retry");
        });
    };
    var handleAddUser = function() {
        setError(null);
        if (!(0,utils/* validatePhoneNumber */.Y0)(mobile)) {
            setError("* Please enter valid mobile number");
            return;
        }
        var headers = {
            headers: {
                "Content-Type": "application/json"
            }
        };
        axios_default().post("/api/backend/entity/profile/" + props.cookieEntityQr + "/fd_exec/create", {
            mobile: mobile,
            entityQrCode: props.cookieEntityQr,
            name: name,
            permissions: permissions/* Roles.FD_EXEC */.G7.FD_EXEC
        }, headers).then(function(resp) {
            setName("");
            setMobile("");
            loadEntityData();
        }).catch(function(err) {
            setError("* Adding user failed. Please retry");
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "m-4",
                children: [
                    !isBasic && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientConfig/* ClientConfig */.A, {
                        cookieQr: props.cookieQr
                    }),
                    isBasic && getUsers()
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./pages/client-settings.tsx






var ClientSettings = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)([
        "qme"
    ]), 2), cookies = ref[0], setCookie = ref[1];
    var cookieQr = cookies.qme ? cookies.qme["qr"] : null;
    var cookieEntityQr = cookies.qme ? cookies.qme["entity_qr"] : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "QMe - Doctor's Settings"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "QMe - Doctor's Settings"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "hospital information system, hospital information management system"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSettingsView, {
                        cookieEntityQr: cookieEntityQr,
                        cookieQr: cookieQr
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var client_settings = (ClientSettings);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9669,5728,9774,2888,179], function() { return __webpack_exec__(32938); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);